import React from "react";

import Loading from "ui/Loading";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";
import { useDateRange } from "providers/WithDateRange";

import FingerprintQueryDetails from "../FingerprintQueryDetails";
import { useOrganizationQueryDetailsQuery } from "./gql/Query.generated";

function OrganizationQueryDetails({
  fingerprint,
  serverGroupId,
  datname,
}: {
  fingerprint: string;
  serverGroupId?: string;
  datname?: string;
}) {
  const { slug } = useCurrentOrganization();
  const { from, to } = useDateRange();
  const { data, loading, error } = useOrganizationQueryDetailsQuery({
    variables: {
      organizationSlug: slug,
      fingerprint,
      serverGroupId,
      datname,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  if (loading || error) {
    return <Loading error={!!error} />;
  }

  return (
    <FingerprintQueryDetails
      fingerprint={fingerprint}
      stats={data.getQueryStatsForFingerprint}
    />
  );
}

export default OrganizationQueryDetails;
